<template>
  <div id="app" :class="style">
    <transition name="fade"><Preloader v-if="fieldType==='preloader'"/></transition>
    <transition name="fade"><TransitPage v-if="showTransitPage"/></transition>
    <RedirectPopup v-if="showRedirectPopup"/>
    <section class="content" v-if="!showRedirectPopup">
      <Header v-if="!iFrame"/>
      <section id="main-block" :class="{withoutPadding: iFrame}">
        <div class="container" v-if="!iFrame">
          <LenderBar v-if="showLenderBar"/>
          <transition name="fade">
            <AuthText v-if="showAuthText" />
          </transition>
          <transition name="fade">
            <div v-if="showTitle" class="form-title__wrap h1-wrap">
              <h2 class="form-title">
                {{title}}
              </h2>
              <Note v-if="hint" :content="hint" />
            </div>
          </transition>
          <div class="form-container">
            <transition name="fade"><IconButtonPicker v-if="fieldType === 'icon-button-picker'"/></transition>
            <transition name="fade"><ButtonPicker v-if="fieldType === 'button-picker'"/></transition>
            <transition name="fade"><InputWithSlider v-if="fieldType === 'input-with-slider'"/></transition>
            <transition name="fade"><Slider v-if="fieldType === 'slider'"/></transition>
            <transition name="fade"><DayPicker v-if="fieldType === 'day-picker'"/></transition>
            <transition name="fade"><SimpleInput v-if="fieldType === 'simple-input'"/></transition>
            <transition name="fade"><NewMaskedInput v-if="fieldType === 'new-masked-input'"/></transition>
            <transition name="fade"><MonthYear v-if="fieldType === 'month-year'"/></transition>
            <transition name="fade"><Radio v-if="fieldType === 'radio'"/></transition>
            <transition name="fade"><Phone v-if="fieldType === 'phone'"/></transition>
            <transition name="fade"><ARPhone v-if="fieldType === 'ar-phone'"/></transition>
            <transition name="fade"><Confirm v-if="fieldType === 'confirm'"/></transition>
            <transition name="fade"><DateField v-if="fieldType === 'date'"/></transition>
            <transition name="fade"><TwoInputs v-if="fieldType === 'two-inputs'"/></transition>
            <transition name="fade"><LenderPicker v-if="fieldType === 'lender-picker'"/></transition>
            <transition name="fade"><ThreeFields v-if="['nss', 'three-fields'].includes(fieldType)"/></transition>
            <transition name="fade"><InputAutocomplete v-if="fieldType === 'input-autocomplete'"/></transition>
            <transition name="fade"><ManualProcessFeed v-if="fieldType === 'feed_manual_process'"/></transition>
            <transition name="fade"><Instantor v-if="fieldType === 'instantor'"/></transition>
            <transition name="fade"><Paylands v-if="fieldType === 'paylands'"/></transition>
            <transition name="fade"><Unnax v-if="fieldType === 'unnax'"/></transition>
            <transition name="fade"><Checkboxes v-if="fieldType === 'agreements_checkboxes'"/></transition>
            <transition name="fade"><ImageUpload v-if="fieldType === 'image-upload'"/></transition>
            <transition name="fade"><Multiple v-if="fieldType === 'multiple'"/></transition>
          </div>
          <transition name="fade">
            <div class="form-buttons__wrap" v-if="fieldType && fieldType!=='preloader'">
              <button class="form-buttons__back" :name="'back_button_' + history[currentStep].name" @click="handleChangeStep(-1)" v-if="showBackButton">
                <span v-if="backText">{{backText}}</span>
                <img v-else src="https://cdn.crezu.net/game_flow/src/assets/img/back.svg" alt="">
              </button>
              <div v-else class="form-buttons__back" style="opacity: 0"></div>
              <button class="form-buttons__next" :name="'continue_button_' + history[currentStep].name" @click="handleChangeStep(+1)" v-if="showNextButton">
                {{nextText}}
              </button>
              <transition name="fade">
                <button class="form-buttons__next form-buttons__next--skip" :name="'skip_button_' + history[currentStep].name" @click="handleSkip()" v-if="showSkipButton">
                  {{textSkipButton}}
                </button>
              </transition>
              <SecurityBadge v-if="textUnder && newDesign && showNextButton" :text="textUnder" />
              <button-link
                v-if="newDesign && showBackButton"
                class="form-buttons__new-back reverse white"
                :name="'back_button_' + history[currentStep].name"
                @click.native="handleChangeStep(-1)"
              >
                {{backText}}
              </button-link>
            </div>
          </transition>
        </div>
        <iframe v-if="iFrame" :src="iFrameLink" class="result_link_iframe"></iframe>
        <EsBottomContent v-if="!iFrame && +country === 1" />
        <PlBottomContent v-if="!iFrame && +country === 14" />
      </section>
      <div v-if="history[currentStep].field['tooltip-bottom']" class="tooltip bottom-tooltip">
        <span class="icon icon-info-line"><info-icon/></span>
        <p class="tooltip-text" v-html="history[currentStep].field['tooltip-bottom']"></p>
      </div>
    </section>
  </div>
</template>

<script>
import Header from './components/Header'
import Footer from './components/Footer'
import IconButtonPicker from './components/fields/IconButtonPicker'
import ButtonPicker from './components/fields/ButtonPicker'
import InputWithSlider from './components/fields/InputWithSlider'
import Slider from './components/fields/Slider'
import DayPicker from './components/fields/DayPicker'
import SimpleInput from './components/fields/SimpleInput'
import NewMaskedInput from './components/fields/NewMaskedInput'
import MonthYear from './components/fields/MonthYear'
import Radio from './components/fields/Radio'
import Phone from './components/fields/Phone'
import ARPhone from './components/fields/ARPhone'
import Confirm from './components/fields/Confirm'
import DateField from './components/fields/DateField'
import TwoInputs from './components/fields/TwoInputs'
import Preloader from './components/preloader'
import InfoIcon from './components/assetComponents/InfoIcon'
import LenderPicker from './components/fields/LenderPicker'
import ThreeFields from './components/fields/ThreeFields'
import InputAutocomplete from './components/fields/InputAutocomplete'
import ManualProcessFeed from './components/fields/ManualProcessFeed'
import TransitPage from './components/TransitPage'
import LenderBar from './components/LenderBar'
import RedirectPopup from './components/RedirectPopup'
import Instantor from './components/fields/Instantor'
import Paylands from './components/fields/Paylands'
import Unnax from './components/fields/Unnax'
import Checkboxes from './components/fields/Checkboxes'
import ImageUpload from './components/fields/ImageUpload'
import Multiple from './components/fields/Multiple'
import EsDisclaimer from './components/hardcoreComponents/EsDisclaimer'
import ButtonLink from './components/assetComponents/ButtonLink'
import AuthText from './components/assetComponents/AuthText'
import SecurityBadge from './components/assetComponents/SecurityBadge.vue'
import EsBottomContent from './components/hardcoreComponents/EsBottomContent.vue'
import PlBottomContent from './components/hardcoreComponents/PlBottomContent.vue'

import { mapState } from 'vuex'
import sbjs from 'sourcebuster'
import Crezu from '@/utils/'
import { useFakeBacker } from '../../common/composables/useFakeBacker'
import Note from './components/assetComponents/Note.vue'

const host = window.location.hostname
const countriesWithSkipConfirm = [1]
const fakeBackerDomains = ['localhost'] // temporary disable on all domains
const domainsWithoutBackBlocking = ['finmatcher.com', 'staging.finmatcher.com']

export default {
  name: 'App',
  components: {
    SecurityBadge,
    Note,
    RedirectPopup,
    LenderBar,
    TransitPage,
    ManualProcessFeed,
    LenderPicker,
    Preloader,
    TwoInputs,
    DateField,
    Confirm,
    Phone,
    ARPhone,
    Radio,
    MonthYear,
    SimpleInput,
    NewMaskedInput,
    DayPicker,
    InputWithSlider,
    IconButtonPicker,
    ButtonPicker,
    Slider,
    Header,
    Footer,
    InfoIcon,
    ThreeFields,
    InputAutocomplete,
    Instantor,
    Paylands,
    Unnax,
    Checkboxes,
    ImageUpload,
    EsDisclaimer,
    ButtonLink,
    AuthText,
    Multiple,
    EsBottomContent,
    PlBottomContent,
  },
  data () {
    return {
      progressBarOptions: [],
      provider: +Crezu.common.getURLParameter('provider') || window.provider || 3,
      country: +Crezu.common.getURLParameter('country') || window.country || 2,
      showNote: false,
      showRatingDescription: false,
      newDesign: window.newDesign || ['finmatcher.com'].includes(window.location.hostname),
      style: ''
    }
  },
  computed: {
    ...mapState({
      history: state => state.history,
      currentStep: state => state.currentStep,
      fieldType: state => state.history[state.currentStep].field['game-type'],
      config: state => state.config,
      specificProviders: state => state.specificProviders,
      CDNUrl: state => state.CDNUrl,
      showNextButton: state => {
        let pickerTypes = ['icon-button-picker', 'button-picker', 'day-picker', 'radio', 'feed_manual_process', 'instantor', 'paylands', 'unnax']
        let excludedNames = [] // 'zip']
        return (pickerTypes.indexOf(state.history[state.currentStep].field['game-type']) === -1 &&
          excludedNames.indexOf(state.history[state.currentStep].name) === -1)
      },
      showBackButton: state => {
        let pickerTypes = ['feed_manual_process', 'instantor', 'paylands', 'unnax']
        return state.currentStep && (pickerTypes.indexOf(state.history[state.currentStep].field['game-type']) === -1) && !state.additionalParams.lender_id
      },
      iFrame: state => state.iFrame,
      iFrameLink: state => state.iFrameLink,
      additionalParams: state => state.additionalParams,
      showTransitPage: state => state.showTransitPage,
      showRedirectPopup: state => state.showRedirectPopup,
      hardcoreAPILenders: state => state.hardcoreAPILenders,
      APIMethod: state => state.method,
      offers: state => state.offers,
      hint: state => {
        const field = state.history[state.currentStep].field
        return field && field.hint
      },
      textUnder: state => state.config.params.textUnder,
      showAuthText: state => state.showAuthText,
      textSkipButton: state => state.config.params.skipButton || 'SALTAR',
      showSkipButton: state =>
        state.showSkipButton &&
        state.history[state.currentStep].name === 'confirm' &&
        countriesWithSkipConfirm.includes(+this.additionalParams.country)
    }),
    showLenderBar: function () {
      return this.hardcoreAPILenders && this.additionalParams.lender_id && this.hardcoreAPILenders[this.additionalParams.lender_id]
    },
    title () {
      let label = this.history[this.currentStep].field.label.split('*').join('')
      if (this.history[this.currentStep].name === 'name') {
        if (+this.additionalParams.country === 9) {
          label = 'Họ và tên'
        } else if (+this.additionalParams.country === 3) {
          label = 'Complete your data'
        } else if ([1, 2, 4, 5, 6].indexOf(+this.additionalParams.country) > -1) {
          label = 'Nombre y apellido completo'
        } else if (+this.additionalParams.country === 14) {
          label = 'Informacje osobiste'
        } else {
          label = ''
        }
      }
      return label
    },
    showTitle () {
      const gameType = this.history[this.currentStep].field['game-type']
      return gameType && gameType !== 'preloader'
    },
    nextText () {
      let nextText = this.config.params.continue_button
      if (window.location.href.indexOf('finteres') > -1) nextText = 'Continuar'
      return nextText
    },
    backText () {
      let backText = this.newDesign && this.config.params.back_button
      if (window.location.href.indexOf('finteres') > -1) backText = 'Anterior'
      return backText
    }
  },
  beforeMount () {
    const style = Crezu.common.getURLParameter('style')
    console.log('created', style)
    if (style) this.style = `style-${style}`
  },
  mounted () {
    this.$store.commit('CHANGE_ADDITIONAL_PARAMS', { provider: this.provider, country: this.country })
    this.setEnv()
    // UTM, Google data and Fingerprint  and offers
    this.initMarketingData()

    // if (host !== 'localhost') this.onPageCloseHandler()
    this.onPageCloseHandler()

    // init events for integration
    window.addEventListener('go_back', () => this.handleChangeStep(-1))

    if (fakeBackerDomains.includes(host)) {
      const { pushStateGoogle, validateFakeBacker } = useFakeBacker(host, 'pl')
      validateFakeBacker()
      pushStateGoogle()
      this.$store.dispatch('successRedirectPrepare', 'Feed')
    } else if (!domainsWithoutBackBlocking.includes(window.location.hostname)) this.captureBackspace(window) // disable backspace ability

    // add ability to render fields from console
    window.addEventListener('setupNextStep', (e) => {
      this.$store.commit('UPDATE_FIELD', { isValid: true })
      this.$store.dispatch('processNextFields', e.detail)
    })

    // add ability to redirect from console
    window.addEventListener('proceedRedirect', (e) => {
      this.$store.dispatch('proceedRedirect', e.detail)
    })

    // add ability to go to offers from console
    window.addEventListener('goToOffers', (e) => {
      this.$store.dispatch('goToOffers', e.detail)
    })

    // reload page when user returns from API of Feed (mobile browsers save state and user can't do anything)
    // this.initReloaderWhenReturn()

    // add Safari header bg color
    // this.setSafariHeaderBG()

    this.initClickListener()
  },
  beforeDestroy() {
    window.onbeforeunload = null;
  },
  methods: {
    getConfigUrl () {
      let goProd = host !== 'localhost' && !host.includes('192.168')
      let prefix = goProd ? this.CDNUrl : ''
      let configURL = `${prefix}/native/configs/default_country_profiles/${this.country}.json`

      // custom config for multilanguage sites
      if (+this.country === 7 && localStorage.getItem('lang') === 'ru') configURL = `${prefix}/native/configs/7-ru.json`
      if (+this.country === 8 && localStorage.getItem('lang') === 'kz') configURL = `${prefix}/native/configs/8-kz.json`
      if (+this.country === 10 && localStorage.getItem('lang') === 'en') configURL = `${prefix}/native/configs/10-en.json`
      return configURL
    },
    handleChangeStep (incr) {
      if (incr < 0 && this.currentStep === 0) return
      this.$store.dispatch('nextStepPrepare', incr)
      window.scrollTo({top: 0, behavior: 'smooth'})
    },
    captureBackspace (global) {
      if (typeof (global) === 'undefined') {
        throw new Error('window is undefined')
      }
      let _hash = '!'
      let noBackPlease = function () {
        global.location.href += '#'
        global.setTimeout(function () {
          global.location.href += '!'
        }, 50)
      }
      let alreadySended = false
      global.onhashchange = function () {
        if (global.currentStep > 0 && !alreadySended) {
          alreadySended = true
          window.dataLayer = window.dataLayer || []
          window.dataLayer.push({
            'event': 'backwardDetected'
          })
        }
        if (global.location.hash !== _hash) {
          global.location.hash = _hash
        }
      }
      global.onload = function () {
        noBackPlease()
      }
    },
    setEnv () {
      this.$store.dispatch('setEnv')
    },
    initMarketingData () {
      if (Crezu.common.getURLParameter('f_l')) {
        console.log('don\'t init sbjs')
        sbjs.init({domain: 'f_l'})
      } else {
        console.log('init sbjs')
        sbjs.init({})
      }

      const getPathFromReferrer = () => {
        if (!document.referrer) return ''

        try {
          const referrer = new URL(document.referrer)
          if (document.location.hostname === referrer.hostname) {
            let path = referrer.pathname.replace(/^\/|\/$/g, '')
            return path || '/'
          } else {
            return document.referrer
          }
        } catch (e) {
          return ''
        }
      }

      const getTrafficbackUtms = () => {
        let searchParams = null
        try {
          searchParams = new URL(sbjs.get.current_add.ep).searchParams
        } catch (_) {
          searchParams = new URLSearchParams(window.location.search)
        }

        const utm_source = searchParams.get('utm_source')
        const utm_campaign = searchParams.get('utm_campaign')
        if (utm_source === 'redirect' && utm_campaign === 'trafficback') {
          searchParams.delete('utm_source')
          searchParams.delete('utm_campaign')
          return searchParams.toString()
        }
        return null
      }

      window.sbjs = sbjs
      this.$store.dispatch('getConfig', this.getConfigUrl()).then((response) => {
        let params = {
          provider: this.provider,
          country: this.country,
          utm_source: Crezu.common.getURLParameter('utm_source') || sbjs.get.current.src || '(none)',
          utm_medium: Crezu.common.getURLParameter('utm_medium') || sbjs.get.current.mdm || '(none)',
          utm_campaign: Crezu.common.getURLParameter('utm_campaign') || sbjs.get.current.cmp || '(none)',
          utm_content: Crezu.common.getURLParameter('utm_content') || sbjs.get.current.cnt || '(none)',
          utm_term: Crezu.common.getURLParameter('utm_term') || sbjs.get.current.trm || '(none)',
          ga_client_id: Crezu.common.getGAClientID(),
          gclid: Crezu.common.getURLParameter('gclid') || this.$cookie.get('gclid') || '',
          ttclid: Crezu.common.getURLParameter('ttclid') || this.$cookie.get('ttclid') || '',
          msclkid: Crezu.common.getURLParameter('msclkid') || this.$cookie.get('msclkid') || '',
          kwaiclid: this.$cookie.get('kwaiclid') || '',
          device: Crezu.common.detectDevice(),
          fingerprint: null,
          fb_fpc: this.$cookie.get('_fbc'),
          fb_fbp: this.$cookie.get('_fbp'),
          screen_size: Crezu.common.getScreenSize(),
          dpi: Crezu.common.getDPI(),
          internal_source: Crezu.common.getURLParameter('internal_source') || getPathFromReferrer(),
          referrer: this.$cookie.get('indexReferrer') || document.referrer,
          trafficback_utms: getTrafficbackUtms(),
          session_id: this.$cookie.get('session_id'),
        }
        let exp_flow = Crezu.common.getURLParameter('exp_flow')
        if (exp_flow) {
          if (exp_flow.includes('!')) exp_flow = exp_flow.replaceAll('!', '')
          params.exp_flow = exp_flow
          this.$store.dispatch('pushGAEvent', {
            event: 'crezuFlow',
            flow: exp_flow,
          })
        }
        if (+this.country === 10) params.is_terms_accepted = 'on'
        this.$store.commit('CHANGE_ADDITIONAL_PARAMS', params)
        this.$store.dispatch('getFingerprint')

        this.$store.dispatch('sendFormStepLandedEvent')
      })
    },
    droppedEmailValid () {
      let result = false
      for (const i in this.history) {
        if (this.history[i].name === 'email' && this.history[i].isValid) result = this.history[i].value
      }
      return result
    },
    onPageCloseHandler () {
      window.onbeforeunload = function () {
        return '¿De verdad quieres cerrar esta página?'
      }
      const vm = this
      const lead_id = localStorage.getItem('leadId') || localStorage.getItem('lead_id')
      window.addEventListener('beforeunload', function () {
        if (!window.succesRedirect) {
          vm.$store.dispatch('pushGAEvent', 'formFillingHistoryDropped')
          if (vm.APIMethod === '/process') {
            vm.$store.dispatch('hubEvent', {
              lead_id,
              state_type: 'dropped_2_step',
              token: localStorage.getItem('sentFirebaseMessagingToken')
            })
          }
          if (vm.APIMethod === '/form' && lead_id) {
            vm.$store.dispatch('hubEvent', {
              lead_id,
              state_type: 'site_open',
              token: localStorage.getItem('sentFirebaseMessagingToken')
            })
          }
          if (vm.APIMethod === '/form' && vm.droppedEmailValid() && !lead_id && !vm.$cookie.get('abandoned_application')) {
            vm.$cookie.set('abandoned_application', 1, { expires: '1D' })
            vm.$store.dispatch('hubEvent', {
              lead_id: null,
              state_type: 'abandoned_application',
              token: localStorage.getItem('sentFirebaseMessagingToken'),
              email: vm.droppedEmailValid(),
              country_id: vm.additionalParams.country
            })
          }
          const fieldName = vm.$store.state.history[vm.$store.state.currentStep].name || ''
          const approvedFields = ['confirm', 'moneyman_paylands', 'moneyman_unnax']
          // TODO: delete moneyman additional
          if (approvedFields.includes(fieldName)) vm.$store.dispatch('sendCrezuEvent', {
            id: 24,
            sub2: fieldName,
            sub3: `${fieldName}_drop`
          })
        }
      })
    },
    async handleSkip () {
      try {
        await this.$store.dispatch('skipConfirm')
      } catch (e) {
        console.log(e)
      }
      this.$store.commit('UPDATE_FIELD', { isValid: true, value: '' })
      this.handleChangeStep(+1)
    },
    initClickListener () {
      const vm = this
      window.onclick = function (event) {
        const input = event.target.closest('input')
        const name = input && input.getAttribute('name')
        if (name) {
          vm.$store.dispatch('sendCrezuEvent', { id: 5, data: { sub4: 'fieldFocus', sub5: name } })
        }
      }
    },
  }
}
</script>

<style lang="scss">
  @import "./assets/scss/index.scss";
  //@import "./assets/scss/new-style.scss";
  .withoutPadding {
    padding: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue